export class ShowHide {
    trigger: HTMLElement;
    target: HTMLElement;
    triggerClass: string;
    targetClass: string;
    maxHeight: boolean;

    constructor(trigger: HTMLElement, target: HTMLElement, clickOutside: boolean = false, maxHeight: boolean = false, triggerClass: string = 'is-active', targetClass: string = 'is-visible') {
        this.trigger = trigger;
        this.target = target;
        this.triggerClass = triggerClass;
        this.targetClass = targetClass;
        this.maxHeight = maxHeight;
        if (clickOutside) {
            this.addClickOutsideHandler();
        }
        this.addTriggerEvents();
    }

    addClickOutsideHandler() {
        document.addEventListener('click', (event: MouseEvent) => {
            this.clickOutside(event);
        });
    }

    clickOutside(event: MouseEvent) {
        let parents: HTMLElement[] = [
            this.trigger,
            this.target
        ];
        let clickOutside: boolean = true;
        parents.forEach((element: HTMLElement) => {
            if (element.contains(event.target as HTMLElement)) {
                clickOutside = false;
            }
        });
        if (clickOutside === true) {
            this.hide();
        }
    }

    addTriggerEvents() {
        this.trigger.addEventListener('click', () => {
            if (this.trigger.classList.contains(this.triggerClass)) {
                this.hide();
            }
            else {
                this.show();
            }
        });
    }

    show() {
        this.trigger.classList.add(this.triggerClass);
        this.target.classList.add(this.targetClass);
        if (this.maxHeight) {
            this.target.style.maxHeight = this.target.scrollHeight + "px";
        }
    }

    hide() {
        this.trigger.classList.remove(this.triggerClass);
        this.target.classList.remove(this.targetClass);
        if (this.maxHeight) {
            this.target.style.maxHeight = null;
        }
    }

}
